import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { ContractorEndpoints } from '../../config/contractor/contractor-end-point';

@Injectable({
  providedIn: 'root'
})
export class ContractorService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }
  
  getContractor<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(ContractorEndpoints.GetContractor, reqModel);
   } 

  addUpdateContractor<T>(model: any): Observable<HttpResponse<T>> {
   return this.genericApiService.post(ContractorEndpoints.SaveContractor, model);
   }
 
  deleteContractor<T>(ContractorId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${ContractorEndpoints.DeleteContractor}/${ContractorId}/${SiteId}`);
   }

  //  getContractorDropDown<T>(siteId:number,ContractorId:number): Observable<any>{    
  //   return this.genericApiService.post(ContractorEndpoints.GetContractorList, siteId,ContractorId);
  //  }

  getContractorDropDown<T>(SiteId:number,ContractorId:number): Observable<any>{ 
    return this.genericApiService.get<T>(`${ContractorEndpoints.GetContractorList}/${SiteId}/${ContractorId}`);
   }

   getTechnicianDropDown<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(ContractorEndpoints.GetTechnicianList, model);
    }

  //  getTechnicianDropDown<T>(SiteId:number,TechnicianId:number): Observable<any>{ 
  //   return this.genericApiService.get<T>(`${ContractorEndpoints.GetTechnicianList}/${SiteId}/${TechnicianId}`);
  //  }
  //  getContractorDropDown<T>(siteId:number,ContractorId:number): Observable<any>{    
  //   return this.genericApiService.get(ContractorEndpoints.GetContractorList, siteId,ContractorId);
  //  }
   
  getContractordataById<T>(id: string): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(`${ContractorEndpoints.GetContractordataById}/${id}`);
   }


   getTechnician<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(ContractorEndpoints.GetTechnician, reqModel);
   } 

  addUpdateTechnician<T>(model: any): Observable<HttpResponse<T>> {
   return this.genericApiService.post(ContractorEndpoints.SaveTechnician, model);
   }
 
  deleteTechnician<T>(TechnicianId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${ContractorEndpoints.DeleteTechnician}/${TechnicianId}/${SiteId}`);
   }

  
}
